import { Node, mergeAttributes } from '@tiptap/core'
import { VueNodeViewRenderer } from '@tiptap/vue-3'
import VariableNodeView from './VariableNodeView.vue'

export interface VariableOptions {
  HTMLAttributes: Record<string, unknown>
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    variable: {
      insertVariable: (name: string) => ReturnType
    }
  }
}

export const Variable = Node.create<VariableOptions>({
  name: 'variable',

  group: 'inline',

  inline: true,

  selectable: true,

  atom: true,

  addOptions() {
    return {
      HTMLAttributes: {}
    }
  },

  addAttributes() {
    return {
      name: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-variable'),
        renderHTML: (attributes) => {
          return {
            'data-variable': attributes.name
          }
        }
      }
    }
  },

  parseHTML() {
    return [
      {
        tag: 'span[data-variable]'
      }
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, { class: 'variable-node' }),
      `{{${HTMLAttributes['data-variable']}}}`
    ]
  },

  addNodeView() {
    return VueNodeViewRenderer(VariableNodeView)
  },

  addCommands() {
    return {
      insertVariable:
        (name: string) =>
        ({ commands }) => {
          return commands.insertContent([
            {
              type: this.name,
              attrs: { name }
            },
            { type: 'text', text: ' ' }
          ])
        }
    }
  }
})
